import React, {useEffect} from "react";
import {TextField} from "@reside/ui";
import {useFormikContext} from "formik";

import {FacilityPccMappingFormValues} from "./types";

/**
 * PCC connection identifiers. Document upload categories are configured per
 * workflow in WorkflowSettingsSection.
 */
export const FormFields = ({
  isErrorUpdatingPccFacilityMapping,
}: {
  isPccEnabled: boolean;
  isErrorUpdatingPccFacilityMapping: boolean;
}): JSX.Element => {
  const {values, resetForm, initialValues} =
    useFormikContext<FacilityPccMappingFormValues>();

  useEffect(() => {
    if (isErrorUpdatingPccFacilityMapping) {
      if (initialValues.pccOrganizationId) {
        resetForm();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isErrorUpdatingPccFacilityMapping, resetForm]);

  const anyPccChecboxIsChecked = Boolean(values.pccFeatureFlags.length);

  return (
    <>
      <TextField
        label="PointClickCare Organization UUID"
        name="pccOrganizationId"
        disabled={anyPccChecboxIsChecked}
      />
      <TextField
        label="PointClickCare Facility ID"
        name="pccFacilityId"
        format="integer"
        disabled={anyPccChecboxIsChecked}
      />
    </>
  );
};
